import React, { useState } from 'react';
import styles from './refunds.module.scss';
import DashboardNavbar from '../../../examples/Navbars/DashboardNavbar';
import DashboardLayout from '../../../examples/LayoutContainers/DashboardLayout';
import { useTranslation } from 'react-i18next';
import useFetchRefundsData from './useFetchRefundsData';
import RefundsTable from './refundsTable/refundsTable';
import SoftTypography from 'components/SoftTypography';
import SoftBox from '../../../components/SoftBox';
import { useGenerateUuid } from 'shared/utils/useGenerateUuid';
import { emit$, AppEvents } from 'shared/services/app-events';
import SearchField from 'shared/components/SearchField/SearchField';

const Refunds = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState('');
  const { data, fetchData } = useFetchRefundsData();

  const tableUuid = useGenerateUuid();

  const handleSearchButtonClick = () => {
    emit$(AppEvents.RESET_TABLE_COUNTER, tableUuid);
    fetchData(filter.trim());
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className={styles.refunds} data-testid="refunds">
        <SoftBox
          sx={{
            marginTop: '6rem',
          }}
        >
          <SoftTypography
            variant="h2"
            fontWeight="bold"
            sx={{ marginBottom: '2rem' }}
          >
            {t('REFUNDS.header')}
          </SoftTypography>
        </SoftBox>
        <SearchField
          searchFunc={handleSearchButtonClick}
          searchCriteria={filter}
          onSearchCriteriaChange={(event) =>
            setFilter(event.target.value)
          }
          inputLabel={t('REFUNDS.search')}
          inputPlaceholder={t('REFUNDS.search')}
          buttonText={t('REFUNDS.searchButton')}
        />
        <RefundsTable tableUuid={tableUuid} data={data}></RefundsTable>
      </div>
    </DashboardLayout>
  );
};

Refunds.propTypes = {};

Refunds.defaultProps = {};

export default Refunds;
